// src/components/settings/CatalogSyncPanel.js
// Ayarlar sayfasının "Katalog Senkronu" sekmesi. Nadiren kullanılan bir araç;
// tarife sayfalarına dağıtmak yerine burada tek yerde duruyor. Asıl iş
// CatalogSyncModal'da (önce dry run, sonra onay).
import React, { useState } from 'react';
import CatalogSyncModal from '../catalog/CatalogSyncModal';
import styles from './CatalogSyncPanel.module.css';

const CatalogSyncPanel = () => {
  const [isSyncOpen, setIsSyncOpen] = useState(false);

  return (
    <div className={styles.section}>
      <div className={styles.card}>
        <div className={styles.cardText}>
          <h2 className={styles.cardTitle}>Sağlayıcı katalogunu senkronize et</h2>
          <p className={styles.cardDescription}>
            Sağlayıcıda olup bizde olmayan paketleri ve planları ekler. Yalnızca <strong>ekleme</strong> yapar:
            hiçbir satır silinmez, hiçbir fiyat değişmez. Önce önizleme (dry run) gösterilir, onaylamadan
            hiçbir şey yazılmaz.
          </p>
        </div>
        <button type="button" className={styles.syncButton} onClick={() => setIsSyncOpen(true)}>
          Senkronizasyonu başlat
        </button>
      </div>

      <div className={styles.steps}>
        <h3 className={styles.stepsTitle}>Senkrondan sonra</h3>
        <ol className={styles.stepList}>
          <li>Eklenen paketler <strong>yayına kapalı</strong> gelir; uygulamada görünmez.</li>
          <li>İlgili tarife sayfasında <strong>“Pasifleri göster”</strong>i açıp planlara fiyat girin.</li>
          <li>Paketi <strong>yayına alın</strong> ve <strong>“Play'e yayınla”</strong> ile Google Play'e basın.</li>
        </ol>
      </div>

      <CatalogSyncModal isOpen={isSyncOpen} onClose={() => setIsSyncOpen(false)} />
    </div>
  );
};

export default CatalogSyncPanel;
